import React, { useRef, useMemo } from "react";
import { useReceiptsStore } from "../../../../config/stores";
import AntdModal from "../../../../components/common/AntdModal";
import AntdTable from "../../../../components/common/AntdTable";
import dayjs from "dayjs";
import PrintOutHeader from "../../../../components/shared/PrintOutHeader";
import converter from "number-to-words";
import { capitalize } from "lodash";
import { useReactToPrint } from "react-to-print";
import AppButton from "../../../../components/common/AppButton";
import { AiFillPrinter } from "react-icons/ai";
import appConfig from "../../../../config/config.json";

const ReceiptDetails = () => {
  const receiptsStore = useReceiptsStore();
  const { receiptDetails, receipts } = receiptsStore;


  const receiptNumber = useMemo(() => {
    if (!receiptDetails?.id || !receipts?.receipts) {
      return null;
    }

  
    const allReceipts = Array.isArray(receipts.receipts) 
      ? [...receipts.receipts] 
      : [];

  
    const sortedReceipts = allReceipts.sort((a, b) => {
      const dateA = dayjs(a.created_at || a.date);
      const dateB = dayjs(b.created_at || b.date);
      return dateA - dateB; 
    });


    const receiptIndex = sortedReceipts.findIndex(
      (receipt) => receipt.id === receiptDetails.id
    );


    if (receiptIndex === -1) {
      return null;
    }


    return 219 + receiptIndex;
  }, [receiptDetails?.id, receipts?.receipts]);

  const closeModal = () => {
    receiptsStore.setShowViewReceiptDetails(false);
  };

  const contentRef = useRef();

  const handlePrint = useReactToPrint({
    contentRef,

    documentTitle: `Receipt_${dayjs(receiptDetails?.date).format(
      "DD_MM_YYYY_HH_mm"
    )}`,
  });

  const onPrint = () => {
    setTimeout(() => {
      handlePrint();
    }, [10]);
  };

  return (
    <div>
      {receiptsStore.showReceiptDetails && (
        <AntdModal
          open={receiptsStore.showReceiptDetails}
          title={"RECEIPT DETAILS"}
          footer={[
            <AppButton
              text="DOWNLOAD"
              onClick={onPrint}
              iconBefore={<AiFillPrinter />}
            />,
          ]}
          size="large"
          closeModal={closeModal}
        >
          <AntdTable
            showHeader={false}
            bordered={false}
            loading={receiptsStore.gettingReceiptDetails}
            columns={[
              {
                dataIndex: "title",
              },
              {
                dataIndex: "value",
                render: (value) => <span className="fw-bold">{value}</span>,
              },
            ]}
            data={[
              {
                key: 1,
                title: "Date",
                value: dayjs(receiptDetails?.date).format("DD/MM/YYYY"),
              },
              {
                key: 2,
                title: "Amount",
                value: receiptDetails?.amount?.toLocaleString(),
              },
              {
                key: 3,
                title: "Account",
                value: receiptDetails?.account?.name,
              },
              {
                key: 3,
                title: "From",
                value:
                  receiptDetails?.donor?.name ||
                  receiptDetails?.source_of_funds,
              },
              {
                key: 4,
                title: "Project",
                value: receiptDetails?.project?.name,
              },
              {
                key: 5,
                title: "Created By",
                value: `${receiptDetails?.created_by?.first_name || ""} ${
                  receiptDetails?.created_by?.other_names || ""
                }`,
              },
              {
                key: 1,
                title: "Created At",
                value: dayjs(receiptDetails?.created_at).format(
                  "DD/MM/YYYY HH:mm"
                ),
              },
              {
                key: 5,
                title: "Updated By",
                value: `${receiptDetails?.updated_by?.first_name || ""} ${
                  receiptDetails?.updated_by?.other_names || ""
                }`,
              },
              {
                key: 1,
                title: "Updated At",
                value: dayjs(receiptDetails?.updated_at).format(
                  "DD/MM/YYYY HH:mm"
                ),
              },
            ]}
          />

          <div className="d-none">
            <div className="p-2 border m-1" ref={contentRef}>
              <style type="text/css" media="print">
                {"@page { size: A2 landscape; padding: 15px; }"}
              </style>
              <PrintOutHeader />
              <div className="row gap-2 m-1 mt-3">
                <div className="col-4">
                  No:{" "}
                  <span className="fw-bold text-danger">
                    {receiptNumber || "N/A"}
                  </span>
                </div>
                <div className="col-3">
                  <div className="text-center rounded border border-dark fw-bold ms-1">
                    RECEIPT
                  </div>
                </div>
                <div className="col-4 text-end">
                  Date:{" "}
                  <span className="fw-bold">
                    {dayjs(receiptDetails?.date).format("DD/MM/YYYY")}
                  </span>
                </div>
              </div>

              <div className="p-2">
                <table className="table table-borderless">
                  <tbody>
                    <tr>
                      <td className="w-25">Received with thanks from:</td>
                      <td className="fw-bold ">
                        {receiptDetails?.donor?.name ||
                          receiptDetails?.source_of_funds}
                      </td>
                    </tr>
                    <tr>
                      <td className="w-25">The sum Ugandan Shillings:</td>
                      <td className="fw-bold ">
                        {capitalize(
                          converter.toWords(receiptDetails?.amount || 0)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="w-25">Being Payment of:</td>
                      <td className="fw-bold ">{receiptDetails?.details}</td>
                    </tr>
                    <tr>
                      <td className="w-25">Amount:</td>
                      <td className="fw-bold ">
                        UGX {receiptDetails?.amount?.toLocaleString()}
                      </td>
                      <td>Balance</td>
                      <td className="fw-bold">
                        UGX {(receiptDetails?.balance ?? 0).toLocaleString()}
                      </td>
                    </tr>
                    <tr>
                      <td className="w-25">Signature:</td>
                      <td className="fw-bold ">
                        {receiptDetails?.created_by?.signature && (
                          <img
                            src={`${appConfig.server_url}${receiptDetails?.created_by?.signature}`}
                            alt="signature"
                            width="120"
                            height="60"
                            style={{ objectFit: "contain" }}
                          />
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </AntdModal>
      )}
    </div>
  );
};

export default ReceiptDetails;
